import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface MetricCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  variant?: "primary" | "secondary" | "success" | "warning" | "info" | "accent";
  className?: string;
}

const variantStyles = {
  primary: "bg-gradient-to-br from-primary/10 to-primary/5 border-primary/20",
  secondary: "bg-gradient-to-br from-secondary/10 to-secondary/5 border-secondary/20",
  success: "bg-gradient-to-br from-green-500/10 to-green-500/5 border-green-500/20",
  warning: "bg-gradient-to-br from-yellow-500/10 to-yellow-500/5 border-yellow-500/20",
  info: "bg-gradient-to-br from-blue-500/10 to-blue-500/5 border-blue-500/20",
  accent: "bg-gradient-to-br from-purple-500/10 to-purple-500/5 border-purple-500/20"
};

const iconStyles = {
  primary: "text-primary",
  secondary: "text-secondary-foreground",
  success: "text-green-600 dark:text-green-400",
  warning: "text-yellow-600 dark:text-yellow-400", 
  info: "text-blue-600 dark:text-blue-400",
  accent: "text-purple-600 dark:text-purple-400"
};

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  icon,
  variant = "primary",
  className
}) => {
  return (
    <Card className={cn(
      "transition-all duration-200 hover:shadow-md",
      variantStyles[variant],
      className
    )}>
      <CardContent className="pt-6">
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            <p className="text-2xl font-bold text-foreground">{value}</p>
          </div>
          <div className={cn(
            "p-2 rounded-full bg-background/50",
            iconStyles[variant]
          )}>
            {icon}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};